// Зеркало X5.PDA.Core/Constants/ModelActions/PDFNotesActionsVals.cs
//
// ВНИМАНИЕ: контрагентский API (X5.PDA.CWebApi) эти действия НЕ отдаёт —
// в его контроллерах нет Actions[]. Файл нужен PDFViewer'у, который
// синхронизируется из pda-front. Права контрагента считаются на клиенте,
// см. pages/notes/helpers/contractorNotePermissions.ts.
export const PDFNotesActionsVals = {
    CancelDecisionGIPInWork: 200, // Отменить решение: в статус "В работе ГИП"
    CancelDecisionManualNotCompleted: 201, // Отменить решение: в статус "Не выполнено"
    CompleteManualConfirmCompletion: 202, // Выполнено
    ApproveOnStatusChangeGIPApproved: 203, // Утвердить
    CancelByGIP: 204, // Отменить
    SendForApprovalOnStatusChangeOnCheck: 205, // Отправить на согласование: в статус "На проверке"
    ReturnToExpertOnStatusChangeExpertCorrection: 206, // Вернуть эксперту: в статус "Корректировка экспертом"
    Modify: 207, // Изменить
    Delete: 208, // Удалить
    CompleteCompletedGIP: 209, // Выполнено: в статус "Выполнено ГИП"
    ApproveCompleteByInitiatorGIPApproved: 210, // Утвердить "Выполнено инициатором"
    CancelDecisionOnStatusChangeExpertCorrection: 211, // Отменить решение: в статус "Корректировка экспертом"
    CancelCompletion: 212, // Отменить выполнение
    CancelByInitiator: 213, // Отменить "Отмена инициатором"
    ConfirmCompletion: 214, // Подтвердить выполнение
    NoteNotCompletedConfirmNotCompleted: 215, // Замечание не выполнено
    CancelByGIPAgain: 216, // Отменить "Отменено ГИП"
    AssignToExpert: 217, // Назначить на эксперта
};
